/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  GetApiBankAccountAuditLogList200,
  GetApiBankAccountAuditLogListParams,
  GetApiBookingAuditLogList200,
  GetApiBookingAuditLogListParams,
  GetApiBookingInvoiceAuditLogList200,
  GetApiBookingInvoiceAuditLogListParams,
  GetApiBookingTenantAuditLogList200,
  GetApiBookingTenantAuditLogListParams,
  GetApiDepartmentAuditLogList200,
  GetApiDepartmentAuditLogListParams,
  GetApiDepartmentLocationAuditLogList200,
  GetApiDepartmentLocationAuditLogListParams,
  GetApiEmailTemplateAuditLogList200,
  GetApiEmailTemplateAuditLogListParams,
  GetApiInvoiceAuditLogList200,
  GetApiInvoiceAuditLogListParams,
  GetApiLocationAuditLogList200,
  GetApiLocationAuditLogListParams,
  GetApiPropertyAuditLogList200,
  GetApiPropertyAuditLogListParams,
  GetApiPropertyCommissionAuditLogList200,
  GetApiPropertyCommissionAuditLogListParams,
  GetApiPropertyDefaultVendorAuditLogList200,
  GetApiPropertyDefaultVendorAuditLogListParams,
  GetApiPropertyNoteAuditLogList200,
  GetApiPropertyNoteAuditLogListParams,
  GetApiRentAuditLogList200,
  GetApiRentAuditLogListParams,
  GetApiSmsTemplateAuditLogList200,
  GetApiSmsTemplateAuditLogListParams,
  GetApiUserAuditLogList200,
  GetApiUserAuditLogListParams,
  NotFoundErrorResponse,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiBankAccountAuditLogListResponse200 = {
  data: GetApiBankAccountAuditLogList200
  status: 200
}

export type getApiBankAccountAuditLogListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiBankAccountAuditLogListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiBankAccountAuditLogListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiBankAccountAuditLogListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiBankAccountAuditLogListResponseSuccess = (getApiBankAccountAuditLogListResponse200) & {
  headers: Headers;
};
export type getApiBankAccountAuditLogListResponseError = (getApiBankAccountAuditLogListResponse400 | getApiBankAccountAuditLogListResponse401 | getApiBankAccountAuditLogListResponse403 | getApiBankAccountAuditLogListResponse404) & {
  headers: Headers;
};

export type getApiBankAccountAuditLogListResponse = (getApiBankAccountAuditLogListResponseSuccess | getApiBankAccountAuditLogListResponseError)

export const getGetApiBankAccountAuditLogListUrl = (id: string,
    params?: GetApiBankAccountAuditLogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bank-accounts/${id}/audit-logs?${stringifiedParams}` : `/api/bank-accounts/${id}/audit-logs`
}

export const getApiBankAccountAuditLogList = async (id: string,
    params?: GetApiBankAccountAuditLogListParams, options?: RequestInit): Promise<getApiBankAccountAuditLogListResponse> => {
  
  return customFetch<getApiBankAccountAuditLogListResponse>(getGetApiBankAccountAuditLogListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiBookingAuditLogListResponse200 = {
  data: GetApiBookingAuditLogList200
  status: 200
}

export type getApiBookingAuditLogListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiBookingAuditLogListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiBookingAuditLogListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiBookingAuditLogListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiBookingAuditLogListResponseSuccess = (getApiBookingAuditLogListResponse200) & {
  headers: Headers;
};
export type getApiBookingAuditLogListResponseError = (getApiBookingAuditLogListResponse400 | getApiBookingAuditLogListResponse401 | getApiBookingAuditLogListResponse403 | getApiBookingAuditLogListResponse404) & {
  headers: Headers;
};

export type getApiBookingAuditLogListResponse = (getApiBookingAuditLogListResponseSuccess | getApiBookingAuditLogListResponseError)

export const getGetApiBookingAuditLogListUrl = (id: string,
    params?: GetApiBookingAuditLogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bookings/${id}/audit-logs?${stringifiedParams}` : `/api/bookings/${id}/audit-logs`
}

export const getApiBookingAuditLogList = async (id: string,
    params?: GetApiBookingAuditLogListParams, options?: RequestInit): Promise<getApiBookingAuditLogListResponse> => {
  
  return customFetch<getApiBookingAuditLogListResponse>(getGetApiBookingAuditLogListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiBookingInvoiceAuditLogListResponse200 = {
  data: GetApiBookingInvoiceAuditLogList200
  status: 200
}

export type getApiBookingInvoiceAuditLogListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiBookingInvoiceAuditLogListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiBookingInvoiceAuditLogListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiBookingInvoiceAuditLogListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiBookingInvoiceAuditLogListResponseSuccess = (getApiBookingInvoiceAuditLogListResponse200) & {
  headers: Headers;
};
export type getApiBookingInvoiceAuditLogListResponseError = (getApiBookingInvoiceAuditLogListResponse400 | getApiBookingInvoiceAuditLogListResponse401 | getApiBookingInvoiceAuditLogListResponse403 | getApiBookingInvoiceAuditLogListResponse404) & {
  headers: Headers;
};

export type getApiBookingInvoiceAuditLogListResponse = (getApiBookingInvoiceAuditLogListResponseSuccess | getApiBookingInvoiceAuditLogListResponseError)

export const getGetApiBookingInvoiceAuditLogListUrl = (id: string,
    params?: GetApiBookingInvoiceAuditLogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/booking-invoices/${id}/audit-logs?${stringifiedParams}` : `/api/booking-invoices/${id}/audit-logs`
}

export const getApiBookingInvoiceAuditLogList = async (id: string,
    params?: GetApiBookingInvoiceAuditLogListParams, options?: RequestInit): Promise<getApiBookingInvoiceAuditLogListResponse> => {
  
  return customFetch<getApiBookingInvoiceAuditLogListResponse>(getGetApiBookingInvoiceAuditLogListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiBookingTenantAuditLogListResponse200 = {
  data: GetApiBookingTenantAuditLogList200
  status: 200
}

export type getApiBookingTenantAuditLogListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiBookingTenantAuditLogListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiBookingTenantAuditLogListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiBookingTenantAuditLogListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiBookingTenantAuditLogListResponseSuccess = (getApiBookingTenantAuditLogListResponse200) & {
  headers: Headers;
};
export type getApiBookingTenantAuditLogListResponseError = (getApiBookingTenantAuditLogListResponse400 | getApiBookingTenantAuditLogListResponse401 | getApiBookingTenantAuditLogListResponse403 | getApiBookingTenantAuditLogListResponse404) & {
  headers: Headers;
};

export type getApiBookingTenantAuditLogListResponse = (getApiBookingTenantAuditLogListResponseSuccess | getApiBookingTenantAuditLogListResponseError)

export const getGetApiBookingTenantAuditLogListUrl = (id: string,
    params?: GetApiBookingTenantAuditLogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/booking-tenants/${id}/audit-logs?${stringifiedParams}` : `/api/booking-tenants/${id}/audit-logs`
}

export const getApiBookingTenantAuditLogList = async (id: string,
    params?: GetApiBookingTenantAuditLogListParams, options?: RequestInit): Promise<getApiBookingTenantAuditLogListResponse> => {
  
  return customFetch<getApiBookingTenantAuditLogListResponse>(getGetApiBookingTenantAuditLogListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiDepartmentAuditLogListResponse200 = {
  data: GetApiDepartmentAuditLogList200
  status: 200
}

export type getApiDepartmentAuditLogListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiDepartmentAuditLogListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiDepartmentAuditLogListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiDepartmentAuditLogListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiDepartmentAuditLogListResponseSuccess = (getApiDepartmentAuditLogListResponse200) & {
  headers: Headers;
};
export type getApiDepartmentAuditLogListResponseError = (getApiDepartmentAuditLogListResponse400 | getApiDepartmentAuditLogListResponse401 | getApiDepartmentAuditLogListResponse403 | getApiDepartmentAuditLogListResponse404) & {
  headers: Headers;
};

export type getApiDepartmentAuditLogListResponse = (getApiDepartmentAuditLogListResponseSuccess | getApiDepartmentAuditLogListResponseError)

export const getGetApiDepartmentAuditLogListUrl = (id: string,
    params?: GetApiDepartmentAuditLogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/departments/${id}/audit-logs?${stringifiedParams}` : `/api/departments/${id}/audit-logs`
}

export const getApiDepartmentAuditLogList = async (id: string,
    params?: GetApiDepartmentAuditLogListParams, options?: RequestInit): Promise<getApiDepartmentAuditLogListResponse> => {
  
  return customFetch<getApiDepartmentAuditLogListResponse>(getGetApiDepartmentAuditLogListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiDepartmentLocationAuditLogListResponse200 = {
  data: GetApiDepartmentLocationAuditLogList200
  status: 200
}

export type getApiDepartmentLocationAuditLogListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiDepartmentLocationAuditLogListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiDepartmentLocationAuditLogListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiDepartmentLocationAuditLogListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiDepartmentLocationAuditLogListResponseSuccess = (getApiDepartmentLocationAuditLogListResponse200) & {
  headers: Headers;
};
export type getApiDepartmentLocationAuditLogListResponseError = (getApiDepartmentLocationAuditLogListResponse400 | getApiDepartmentLocationAuditLogListResponse401 | getApiDepartmentLocationAuditLogListResponse403 | getApiDepartmentLocationAuditLogListResponse404) & {
  headers: Headers;
};

export type getApiDepartmentLocationAuditLogListResponse = (getApiDepartmentLocationAuditLogListResponseSuccess | getApiDepartmentLocationAuditLogListResponseError)

export const getGetApiDepartmentLocationAuditLogListUrl = (id: string,
    params?: GetApiDepartmentLocationAuditLogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/department-locations/${id}/audit-logs?${stringifiedParams}` : `/api/department-locations/${id}/audit-logs`
}

export const getApiDepartmentLocationAuditLogList = async (id: string,
    params?: GetApiDepartmentLocationAuditLogListParams, options?: RequestInit): Promise<getApiDepartmentLocationAuditLogListResponse> => {
  
  return customFetch<getApiDepartmentLocationAuditLogListResponse>(getGetApiDepartmentLocationAuditLogListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiEmailTemplateAuditLogListResponse200 = {
  data: GetApiEmailTemplateAuditLogList200
  status: 200
}

export type getApiEmailTemplateAuditLogListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiEmailTemplateAuditLogListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiEmailTemplateAuditLogListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiEmailTemplateAuditLogListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiEmailTemplateAuditLogListResponseSuccess = (getApiEmailTemplateAuditLogListResponse200) & {
  headers: Headers;
};
export type getApiEmailTemplateAuditLogListResponseError = (getApiEmailTemplateAuditLogListResponse400 | getApiEmailTemplateAuditLogListResponse401 | getApiEmailTemplateAuditLogListResponse403 | getApiEmailTemplateAuditLogListResponse404) & {
  headers: Headers;
};

export type getApiEmailTemplateAuditLogListResponse = (getApiEmailTemplateAuditLogListResponseSuccess | getApiEmailTemplateAuditLogListResponseError)

export const getGetApiEmailTemplateAuditLogListUrl = (id: string,
    params?: GetApiEmailTemplateAuditLogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/email-templates/${id}/audit-logs?${stringifiedParams}` : `/api/email-templates/${id}/audit-logs`
}

export const getApiEmailTemplateAuditLogList = async (id: string,
    params?: GetApiEmailTemplateAuditLogListParams, options?: RequestInit): Promise<getApiEmailTemplateAuditLogListResponse> => {
  
  return customFetch<getApiEmailTemplateAuditLogListResponse>(getGetApiEmailTemplateAuditLogListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiInvoiceAuditLogListResponse200 = {
  data: GetApiInvoiceAuditLogList200
  status: 200
}

export type getApiInvoiceAuditLogListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiInvoiceAuditLogListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiInvoiceAuditLogListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiInvoiceAuditLogListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiInvoiceAuditLogListResponseSuccess = (getApiInvoiceAuditLogListResponse200) & {
  headers: Headers;
};
export type getApiInvoiceAuditLogListResponseError = (getApiInvoiceAuditLogListResponse400 | getApiInvoiceAuditLogListResponse401 | getApiInvoiceAuditLogListResponse403 | getApiInvoiceAuditLogListResponse404) & {
  headers: Headers;
};

export type getApiInvoiceAuditLogListResponse = (getApiInvoiceAuditLogListResponseSuccess | getApiInvoiceAuditLogListResponseError)

export const getGetApiInvoiceAuditLogListUrl = (id: string,
    params?: GetApiInvoiceAuditLogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/invoices/${id}/audit-logs?${stringifiedParams}` : `/api/invoices/${id}/audit-logs`
}

export const getApiInvoiceAuditLogList = async (id: string,
    params?: GetApiInvoiceAuditLogListParams, options?: RequestInit): Promise<getApiInvoiceAuditLogListResponse> => {
  
  return customFetch<getApiInvoiceAuditLogListResponse>(getGetApiInvoiceAuditLogListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiLocationAuditLogListResponse200 = {
  data: GetApiLocationAuditLogList200
  status: 200
}

export type getApiLocationAuditLogListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiLocationAuditLogListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiLocationAuditLogListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiLocationAuditLogListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiLocationAuditLogListResponseSuccess = (getApiLocationAuditLogListResponse200) & {
  headers: Headers;
};
export type getApiLocationAuditLogListResponseError = (getApiLocationAuditLogListResponse400 | getApiLocationAuditLogListResponse401 | getApiLocationAuditLogListResponse403 | getApiLocationAuditLogListResponse404) & {
  headers: Headers;
};

export type getApiLocationAuditLogListResponse = (getApiLocationAuditLogListResponseSuccess | getApiLocationAuditLogListResponseError)

export const getGetApiLocationAuditLogListUrl = (id: string,
    params?: GetApiLocationAuditLogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/locations/${id}/audit-logs?${stringifiedParams}` : `/api/locations/${id}/audit-logs`
}

export const getApiLocationAuditLogList = async (id: string,
    params?: GetApiLocationAuditLogListParams, options?: RequestInit): Promise<getApiLocationAuditLogListResponse> => {
  
  return customFetch<getApiLocationAuditLogListResponse>(getGetApiLocationAuditLogListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiPropertyAuditLogListResponse200 = {
  data: GetApiPropertyAuditLogList200
  status: 200
}

export type getApiPropertyAuditLogListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiPropertyAuditLogListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiPropertyAuditLogListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiPropertyAuditLogListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiPropertyAuditLogListResponseSuccess = (getApiPropertyAuditLogListResponse200) & {
  headers: Headers;
};
export type getApiPropertyAuditLogListResponseError = (getApiPropertyAuditLogListResponse400 | getApiPropertyAuditLogListResponse401 | getApiPropertyAuditLogListResponse403 | getApiPropertyAuditLogListResponse404) & {
  headers: Headers;
};

export type getApiPropertyAuditLogListResponse = (getApiPropertyAuditLogListResponseSuccess | getApiPropertyAuditLogListResponseError)

export const getGetApiPropertyAuditLogListUrl = (id: string,
    params?: GetApiPropertyAuditLogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/properties/${id}/audit-logs?${stringifiedParams}` : `/api/properties/${id}/audit-logs`
}

export const getApiPropertyAuditLogList = async (id: string,
    params?: GetApiPropertyAuditLogListParams, options?: RequestInit): Promise<getApiPropertyAuditLogListResponse> => {
  
  return customFetch<getApiPropertyAuditLogListResponse>(getGetApiPropertyAuditLogListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiPropertyCommissionAuditLogListResponse200 = {
  data: GetApiPropertyCommissionAuditLogList200
  status: 200
}

export type getApiPropertyCommissionAuditLogListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiPropertyCommissionAuditLogListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiPropertyCommissionAuditLogListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiPropertyCommissionAuditLogListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiPropertyCommissionAuditLogListResponseSuccess = (getApiPropertyCommissionAuditLogListResponse200) & {
  headers: Headers;
};
export type getApiPropertyCommissionAuditLogListResponseError = (getApiPropertyCommissionAuditLogListResponse400 | getApiPropertyCommissionAuditLogListResponse401 | getApiPropertyCommissionAuditLogListResponse403 | getApiPropertyCommissionAuditLogListResponse404) & {
  headers: Headers;
};

export type getApiPropertyCommissionAuditLogListResponse = (getApiPropertyCommissionAuditLogListResponseSuccess | getApiPropertyCommissionAuditLogListResponseError)

export const getGetApiPropertyCommissionAuditLogListUrl = (id: string,
    params?: GetApiPropertyCommissionAuditLogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/property-commissions/${id}/audit-logs?${stringifiedParams}` : `/api/property-commissions/${id}/audit-logs`
}

export const getApiPropertyCommissionAuditLogList = async (id: string,
    params?: GetApiPropertyCommissionAuditLogListParams, options?: RequestInit): Promise<getApiPropertyCommissionAuditLogListResponse> => {
  
  return customFetch<getApiPropertyCommissionAuditLogListResponse>(getGetApiPropertyCommissionAuditLogListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiPropertyDefaultVendorAuditLogListResponse200 = {
  data: GetApiPropertyDefaultVendorAuditLogList200
  status: 200
}

export type getApiPropertyDefaultVendorAuditLogListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiPropertyDefaultVendorAuditLogListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiPropertyDefaultVendorAuditLogListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiPropertyDefaultVendorAuditLogListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiPropertyDefaultVendorAuditLogListResponseSuccess = (getApiPropertyDefaultVendorAuditLogListResponse200) & {
  headers: Headers;
};
export type getApiPropertyDefaultVendorAuditLogListResponseError = (getApiPropertyDefaultVendorAuditLogListResponse400 | getApiPropertyDefaultVendorAuditLogListResponse401 | getApiPropertyDefaultVendorAuditLogListResponse403 | getApiPropertyDefaultVendorAuditLogListResponse404) & {
  headers: Headers;
};

export type getApiPropertyDefaultVendorAuditLogListResponse = (getApiPropertyDefaultVendorAuditLogListResponseSuccess | getApiPropertyDefaultVendorAuditLogListResponseError)

export const getGetApiPropertyDefaultVendorAuditLogListUrl = (id: number,
    params?: GetApiPropertyDefaultVendorAuditLogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/properties/${id}/audit-logs/default-vendors?${stringifiedParams}` : `/api/properties/${id}/audit-logs/default-vendors`
}

export const getApiPropertyDefaultVendorAuditLogList = async (id: number,
    params?: GetApiPropertyDefaultVendorAuditLogListParams, options?: RequestInit): Promise<getApiPropertyDefaultVendorAuditLogListResponse> => {
  
  return customFetch<getApiPropertyDefaultVendorAuditLogListResponse>(getGetApiPropertyDefaultVendorAuditLogListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiPropertyNoteAuditLogListResponse200 = {
  data: GetApiPropertyNoteAuditLogList200
  status: 200
}

export type getApiPropertyNoteAuditLogListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiPropertyNoteAuditLogListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiPropertyNoteAuditLogListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiPropertyNoteAuditLogListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiPropertyNoteAuditLogListResponseSuccess = (getApiPropertyNoteAuditLogListResponse200) & {
  headers: Headers;
};
export type getApiPropertyNoteAuditLogListResponseError = (getApiPropertyNoteAuditLogListResponse400 | getApiPropertyNoteAuditLogListResponse401 | getApiPropertyNoteAuditLogListResponse403 | getApiPropertyNoteAuditLogListResponse404) & {
  headers: Headers;
};

export type getApiPropertyNoteAuditLogListResponse = (getApiPropertyNoteAuditLogListResponseSuccess | getApiPropertyNoteAuditLogListResponseError)

export const getGetApiPropertyNoteAuditLogListUrl = (id: string,
    params?: GetApiPropertyNoteAuditLogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/property-notes/${id}/audit-logs?${stringifiedParams}` : `/api/property-notes/${id}/audit-logs`
}

export const getApiPropertyNoteAuditLogList = async (id: string,
    params?: GetApiPropertyNoteAuditLogListParams, options?: RequestInit): Promise<getApiPropertyNoteAuditLogListResponse> => {
  
  return customFetch<getApiPropertyNoteAuditLogListResponse>(getGetApiPropertyNoteAuditLogListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiRentAuditLogListResponse200 = {
  data: GetApiRentAuditLogList200
  status: 200
}

export type getApiRentAuditLogListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiRentAuditLogListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiRentAuditLogListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiRentAuditLogListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiRentAuditLogListResponseSuccess = (getApiRentAuditLogListResponse200) & {
  headers: Headers;
};
export type getApiRentAuditLogListResponseError = (getApiRentAuditLogListResponse400 | getApiRentAuditLogListResponse401 | getApiRentAuditLogListResponse403 | getApiRentAuditLogListResponse404) & {
  headers: Headers;
};

export type getApiRentAuditLogListResponse = (getApiRentAuditLogListResponseSuccess | getApiRentAuditLogListResponseError)

export const getGetApiRentAuditLogListUrl = (id: string,
    params?: GetApiRentAuditLogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/rents/${id}/audit-logs?${stringifiedParams}` : `/api/rents/${id}/audit-logs`
}

export const getApiRentAuditLogList = async (id: string,
    params?: GetApiRentAuditLogListParams, options?: RequestInit): Promise<getApiRentAuditLogListResponse> => {
  
  return customFetch<getApiRentAuditLogListResponse>(getGetApiRentAuditLogListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiSmsTemplateAuditLogListResponse200 = {
  data: GetApiSmsTemplateAuditLogList200
  status: 200
}

export type getApiSmsTemplateAuditLogListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiSmsTemplateAuditLogListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiSmsTemplateAuditLogListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiSmsTemplateAuditLogListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiSmsTemplateAuditLogListResponseSuccess = (getApiSmsTemplateAuditLogListResponse200) & {
  headers: Headers;
};
export type getApiSmsTemplateAuditLogListResponseError = (getApiSmsTemplateAuditLogListResponse400 | getApiSmsTemplateAuditLogListResponse401 | getApiSmsTemplateAuditLogListResponse403 | getApiSmsTemplateAuditLogListResponse404) & {
  headers: Headers;
};

export type getApiSmsTemplateAuditLogListResponse = (getApiSmsTemplateAuditLogListResponseSuccess | getApiSmsTemplateAuditLogListResponseError)

export const getGetApiSmsTemplateAuditLogListUrl = (id: string,
    params?: GetApiSmsTemplateAuditLogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sms-templates/${id}/audit-logs?${stringifiedParams}` : `/api/sms-templates/${id}/audit-logs`
}

export const getApiSmsTemplateAuditLogList = async (id: string,
    params?: GetApiSmsTemplateAuditLogListParams, options?: RequestInit): Promise<getApiSmsTemplateAuditLogListResponse> => {
  
  return customFetch<getApiSmsTemplateAuditLogListResponse>(getGetApiSmsTemplateAuditLogListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiUserAuditLogListResponse200 = {
  data: GetApiUserAuditLogList200
  status: 200
}

export type getApiUserAuditLogListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiUserAuditLogListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiUserAuditLogListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiUserAuditLogListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiUserAuditLogListResponseSuccess = (getApiUserAuditLogListResponse200) & {
  headers: Headers;
};
export type getApiUserAuditLogListResponseError = (getApiUserAuditLogListResponse400 | getApiUserAuditLogListResponse401 | getApiUserAuditLogListResponse403 | getApiUserAuditLogListResponse404) & {
  headers: Headers;
};

export type getApiUserAuditLogListResponse = (getApiUserAuditLogListResponseSuccess | getApiUserAuditLogListResponseError)

export const getGetApiUserAuditLogListUrl = (id: string,
    params?: GetApiUserAuditLogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/users/${id}/audit-logs?${stringifiedParams}` : `/api/users/${id}/audit-logs`
}

export const getApiUserAuditLogList = async (id: string,
    params?: GetApiUserAuditLogListParams, options?: RequestInit): Promise<getApiUserAuditLogListResponse> => {
  
  return customFetch<getApiUserAuditLogListResponse>(getGetApiUserAuditLogListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


